<template>
  <div class="mongo-instanceProfile-page">
    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row>
        <i-col span="24">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem :label-width="0" prop="db">
              <Select v-model="searchForm.db" clearable filterable @on-change="getInstanceLog()">
                <Option v-for="item in databaseList" :value="item" :key="item" :label="item"></Option>
              </Select>
            </FormItem>
            <FormItem class="mob-align-right">
              <Button type="primary" @click="getAggregateLog()">聚合统计</Button>
              <Button @click="getInstanceLog()" style="margin-left: 10px;">重置</Button>
            </FormItem>
            <FormItem prop="date" style="float: right;text-align:right;margin-right:0;">
              <DatePicker type="daterange" :value="dateValue" :options="dateOption" placement="bottom-end"
                          placeholder="Select date" @on-change="getInstanceLog"></DatePicker>
            </FormItem>
          </Form>
        </i-col>
      </Row>
      <tables ref="instanceLogTable" height="600" search-place="top" v-model="instanceLogData"
              :columns="instanceLogColumns"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceLog"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getInstanceProfile, showDatabaseList, getAggregateProfile} from '@/api/mongodb'

export default {
  name: 'MongoDBInstanceProfile',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        db: 'admin'
      },
      count: 1,
      size: 15,
      page: 1,
      dateValue: [new Date().toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      is_superuser: false,
      instanceLogColumns: [],
      generalColumns: [
        {title: 'op', key: 'op', align: 'center', minWidth: 80},
        {title: 'ns', key: 'ns', align: 'center', minWidth: 80},
        {title: 'command', key: 'command', tooltip: true, align: 'center', minWidth: 100},
        {title: 'millis', key: 'millis', align: 'center', minWidth: 80},
        {title: 'ts',
          key: 'ts',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            return h('div', new Date((params.row.ts.$date)).toLocaleString())
          }
        },
        {title: 'client', key: 'client'}
      ],
      aggregateColumns: [
        {title: '执行次数', key: 'count', minWidth: 100, align: 'center'},
        {title: '执行时长(求和)', key: 'total', minWidth: 130, align: 'center'},
        {title: '语句', key: '_id', tooltip: true, minWidth: 100, align: 'center'}
      ],
      instanceLogData: [],
      databaseList: []
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    searchReset () {
      this.searchForm.db = 'admin'
      this.searchForm.date = [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)]
      this.getInstanceLog()
    },
    refresh () {
      this.getInstanceLog()
    },
    getInstanceLog (value = 1) {
      this.instanceLogColumns = this.generalColumns
      if (typeof value === 'number') {
        this.page = value
      } else {
        let end = new Date(value[1])
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        this.dateValue[0] = value[0]
        this.dateValue[1] = end.toISOString().slice(0, 10)
      }
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        start_time: this.dateValue[0],
        end_time: this.dateValue[1],
        search: this.searchForm.name,
        db: this.searchForm.db
      }
      getInstanceProfile(params).then(res => {
        this.instanceLogData = JSON.parse(res.data.results)
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    },

    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          this.databaseList = res.data.results
        }
      })
    },

    getAggregateLog (value = 1) {
      this.instanceLogColumns = this.aggregateColumns
      if (typeof value === 'number') {
        this.page = value
      } else {
        let end = new Date(value[1])
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        this.dateValue[0] = value[0]
        this.dateValue[1] = end.toISOString().slice(0, 10)
      }
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        start_time: this.dateValue[0],
        end_time: this.dateValue[1],
        db: this.searchForm.db
      }
      getAggregateProfile(params).then(res => {
        this.instanceLogData = JSON.parse(res.data.results)
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    }

  },

  mounted: function () {
    this.getInstanceLog()
    this.getDatabases()
  }
}
</script>
<style lang="less">
  .mongo-instanceProfile-page{
    @media screen and (max-width:640px) {
      h1{
        font-size: 1.5em;
      }
      .ivu-table-wrapper,.ivu-table-body{
        height:auto!important;
      }
      .ivu-divider-horizontal{
          margin: 10px 0 15px;
      }
    }
  }
</style>
